import { useMutation } from "@apollo/client";
import { DOWNLOAD_DOCUMENT } from "../graphql/mutations/Providers";
export default function MessageTableRow(props) {
  const provider_id = parseInt(window.localStorage.getItem("providerID"));
  const patient_id = parseInt(window.localStorage.getItem("patientID"));
  const xref_id = parseInt(window.localStorage.getItem('xrefID'));
    const [downloadDocument] = useMutation(DOWNLOAD_DOCUMENT);
   async function getFile(docType) {
  const file = props.folderName + props.fileName;
  if (!file) return;
  const newTab = window.open("", "_blank");

  try {
    const { data } = await downloadDocument({
      variables: {
        input: {
          fileName: file,
          provider_id,
          patient_id : patient_id || xref_id,
	 document_type: docType
        },
      },
    });
    const downloadUrl = data?.patientdownloaddocuments?.url;
    if (downloadUrl) {
      newTab.location.href = downloadUrl;
    } else {
      console.error("No download URL received from server.");
    }
  } catch (error) {
    console.error("Error downloading document:", error);
  }
}


    return (
        <tr>
            <td style={{ fontSize: '1em', lineHeight: '1.49em' }}><div onClick={()=>{getFile(props.docType)}}>{props.docType}</div></td>
            <td style={{ fontSize: '1em', lineHeight: '1.49em' }}>{props.patientID}</td>
            <td style={{ fontSize: '1em', lineHeight: '1.49em' }}>{props.docSentDate}</td>
        </tr>
        
    )
}
